export const AUTH_TOKEN_NAME = 'token';
export const GENDER_FIELD = 'gender';
